import * as React from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/outline";
import { Text, Button } from "@uikit";
import { useApp } from "@store/app";

interface IProps {
  value?: number;
  title?: string;
  onChange?: (e: number) => void;
  onClose?: () => void;
}

const PersonPicker = ({
  value,
  title = "Number of Golfers",
  onChange,
  onClose,
}: IProps) => {
  const golfers = useApp(($) => $.golfers);
  const addGolfer = useApp(($) => $.addGolfer);
  const removeGolfer = useApp(($) => $.removeGolfer);
  const hideDatePicker = useApp(($) => $.hideDatePicker);
  const hidePeoplePicker = useApp(($) => $.hidePeoplePicker);

  const [count, setCount] = React.useState<number>(value || golfers);

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-40 z-[999] flex items-end sm:items-center justify-center`}
      onClick={(e) => {
        if (e.target !== e.currentTarget) return;
        if (onClose) {
          onClose();
        } else {
          hideDatePicker();
          hidePeoplePicker();
        }
      }}
    >
      <div className="flex justify-center flex-1 sm:flex-none">
        <div
          className={`bg-white rounded-t-lg  sm:rounded-lg   drop-shadow-modal p-5  sm:p-9 w-full transition-all ease-in-out min-w-[100%] sm:min-w-[500px] lg:min-w-[700px]`}
        >
          <div className="mb-4 py-4 sm:py-0">
            <div className="border-t border-b border-grey3 py-3 flex mb-2 items-center justify-between select-none">
              <div>
                <Text size={19} weight="semibold" leading={1.3} color="black80">
                  {title}
                </Text>
              </div>
              <div className="flex">
                <div
                  className="bg-grey w-8 h-8 rounded-md flex justify-center items-center cursor-pointer"
                  onClick={() => {
                    if (value) {
                      setCount(count - 1);
                    } else {
                      removeGolfer();
                    }
                  }}
                >
                  <MinusIcon className="w-5 text-blue" />
                </div>
                <div className="w-11 flex justify-center items-center">
                  <Text size={18} weight="bold" leading={1.3} color="black">
                    {value ? count : golfers || 0}
                  </Text>
                </div>
                <div
                  className="bg-grey w-8 h-8 rounded-md flex justify-center items-center cursor-pointer"
                  onClick={() => {
                    if (value) {
                      setCount(count + 1);
                    } else {
                      addGolfer();
                    }
                  }}
                >
                  <PlusIcon className="w-5 text-blue" />
                </div>
              </div>
            </div>
            <Text size={11} leading={1.5} color="black80">
              For groups larger than 16, please contact us.
            </Text>
          </div>
          <Button
            onClick={() => {
              if (onClose) {
                onChange && onChange(count);
                onClose();
              } else {
                hideDatePicker();
                hidePeoplePicker();
              }
            }}
            size="large"
            color="green"
            width="full"
            className={`my-1 mb-0`}
            text="Done"
          />
        </div>
      </div>
    </div>
  );
};

export default PersonPicker;
